











import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class DynamicDivider extends Vue {
    @Prop({ default: '6px' }) public width!: string;
    @Prop({ default: '4px' }) public height!: string;
    @Prop({ default: 'black' }) public backgroundColor!: string;

}
